import { combineReducers } from 'redux';

import data from './slices/dataSlice';

export default combineReducers({ data });
